
/**
 * Modal z-index.
 */

const modalZIndex = 100;

/**
 * Export `zIndex`.
 */

export const zIndex = {
  dateInput: {
    popper: 1000
  },
  dateRangeInput: {
    fang: 1100,
    picker: 1000
  },
  dropdown: {
    button: 10,
    menu: 200
  },
  modal: {
    backdrop: modalZIndex,
    closeButton: modalZIndex + 2,
    container: modalZIndex + 1
  },
  overlay: modalZIndex - 1,
  snackbar: 300,
  tooltip: 90
};
